import { connect } from 'react-redux';
import { setColumns, setFilters } from '../../actions/index';
import FilterColumns from '../../components/FilterColumns/FilterColumns';



const mapStateToProps = state => {
    return {
        rowFilter: state.rowFilters
    }
};

export default connect(
    mapStateToProps,
    { setColumns, setFilters }
)(FilterColumns);


// WEBPACK FOOTER //
// ./src/containers/FilterColumns/FilterColumnsContainer.js